module.exports = __webpack_public_path__ + "static/media/temp-eating.6809ae8a.png";